export default {
  nav: {
    brand: 'Cemil Kuaför | Hair Design',
    videos: 'Videos',
    gallery: 'Gallery',
    services: 'Services',
    contact: 'Contact',
  },
  hero: {
    title: 'Natural-Looking Micro Link Extensions in Marmaris',
    subtitle:
      'Professional hair design applications that add volume, length, and a natural look to your hair.',
    btnVideos: 'Watch Videos',
    btnWhatsApp: 'Ask on WhatsApp',
  },
  videos: {
    title: 'Application Videos',
    subtitle: 'Discover our micro link results',
    items: [
      { title: 'Micro Link Result', duration: '0:32' },
      { title: 'Natural Transition', duration: '0:28' },
      { title: 'Voluminous Hair Look', duration: '0:35' },
      { title: 'Before / After', duration: '0:41' },
      { title: 'Daily Care Routine', duration: '0:33' },
      { title: 'Color Refresh', duration: '0:30' },
      { title: 'Keratin Treatment Result', duration: '0:36' },
      { title: 'Modern Perm Effect', duration: '0:29' },
      { title: 'Ombre Application', duration: '0:34' },
      { title: 'Shiny Hair Texture', duration: '0:31' },
      { title: 'Cut & Styling', duration: '0:37' },
      { title: 'Bridal Hair Prep', duration: '0:40' },
      { title: 'Natural Wavy Model', duration: '0:27' },
      { title: 'Intensive Volume App', duration: '0:38' },
      { title: 'Creative Hair Design', duration: '0:42' },
    ],
    playIcon: 'Play',
    close: 'Close',
    askWhatsApp: 'Ask on WhatsApp',
  },
  beforeAfter: {
    title: 'Before / After',
    subtitle: 'Our micro link results',
    items: [
      { label: 'Invisible bonds', desc: 'Natural and undetectable application' },
      { label: 'Natural hair match', desc: 'Perfect blend with your own hair' },
      { label: 'Voluminous look', desc: 'Full and lively hair effect' },
      { label: 'Long & healthy hair', desc: 'Professional care results' },
    ],
    contact: 'Get in Touch',
  },
  why: {
    title: 'Why Micro Link?',
    subtitle: 'Professional hair design advantages',
    items: [
      { title: 'Natural look', desc: 'Indistinguishable from your own hair' },
      { title: 'Perfect match', desc: 'Color and texture harmony' },
      { title: 'Comfortable wear', desc: 'Lightweight, non-heavy system' },
      { title: 'Professional application', desc: 'Safe procedure with years of experience' },
      { title: 'Experienced service in Marmaris', desc: 'Special care for local & foreign guests' },
    ],
  },
  services: {
    title: 'Our Services',
    subtitle: 'Premium hair design applications',
    items: [
      {
        title: 'Micro Link',
        desc: 'Natural-looking, lightweight and comfortable hair extension system. Invisible bonds make it indistinguishable from your own hair.',
        badge: 'Popular',
      },
      {
        title: 'Ombre',
        desc: 'Modern and natural gradient color techniques. Professional coloring that adds depth and movement to your hair.',
      },
      {
        title: 'Permanent Blow-dry',
        desc: 'Long-lasting, styled and shiny hair look. Professional treatment resistant to humidity and frizz.',
      },
    ],
    askPrice: 'Ask for price & details',
    viewDetails: 'View Details',
  },
  tourist: {
    title: 'Professional Hair Design Experience in Marmaris',
    desc: 'Professional hairdresser and hair design experience for local and foreign guests in Marmaris. With years of expertise, we offer tailored solutions for every hair type.',
    stats: [
      { value: '15+', label: 'Years Experience' },
      { value: '5000+', label: 'Happy Clients' },
      { value: '3', label: 'Language Support' },
    ],
  },
  salon: {
    title: 'Salon Information',
    name: 'Cemil Kuaför | Hair Design',
    address: 'Tepe Mah. Above DenizBank',
    city: 'Marmaris / Muğla',
    phone: '0531 345 99 87',
    instagram: '@cemilkuaformarmaris',
    hours: 'Every day 09:00 - 20:00',
    getDirections: 'Get Directions',
  },
  whatsapp: {
    cta: 'Ask on WhatsApp',
    message: 'Hello Cemil Kuaför, I would like to get information about micro link application.',
    floatingLabel: 'Message Us',
  },
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Everything you need to know about micro links, ombre & permanent blow-dry',
    items: [
      {
        q: 'How long do micro link extensions last?',
        a: 'With professional application and regular maintenance, micro link extensions last 3–6 months. Periodic maintenance appointments extend their lifespan.',
      },
      {
        q: 'Do micro links damage my natural hair?',
        a: 'No. When applied with correct techniques, micro links cause no damage. They attach to the mid-shaft of your hair, not the roots.',
      },
      {
        q: 'Can ombre and micro links be done on the same day?',
        a: 'Yes, both procedures can be combined in a single session. This way you get both color and length/volume in one appointment.',
      },
      {
        q: 'Why are prices not listed on the website?',
        a: 'Hair type, density, and desired length vary per person, so we provide personalized quotes via WhatsApp instead of fixed prices.',
      },
      {
        q: 'Can I get service while on holiday in Marmaris?',
        a: 'Absolutely. We serve all local and foreign guests with English and Russian-speaking support. Just book an appointment.',
      },
      {
        q: 'How long does the micro link application take?',
        a: 'It typically takes 2–4 hours. Hair density and desired length can affect the duration.',
      },
      {
        q: 'How long does permanent blow-dry last?',
        a: 'Permanent blow-dry remains effective for 3–6 months, significantly reducing the need for daily styling tools.',
      },
      {
        q: 'How do I book an appointment?',
        a: 'You can easily book by messaging us via WhatsApp buttons on the page or by calling us directly.',
      },
      {
        q: 'What should I do before a hair coloring session?',
        a: 'Clean hair is sufficient. Our expert team performs a pre-service hair analysis to determine the best technique for you.',
      },
      {
        q: 'How should I care for my hair after micro links?',
        a: 'We recommend special shampoo and care products. Regular brushing, heat protectant use, and maintenance appointments ensure long-lasting results.',
      },
    ],
  },
  testimonials: {
    title: 'Client Satisfaction',
    subtitle: 'Reviews from our micro link extension clients',
    items: [
      {
        name: 'Ayşe K.',
        role: 'Marmaris',
        text: 'After the micro link application, my hair looks so natural. Nobody notices the extensions. Mr. Cemil\'s professionalism is truly on another level.',
        service: 'Micro Link Extensions',
      },
      {
        name: 'Elena S.',
        role: 'Moscow',
        text: 'I came during my Marmaris holiday, the result was excellent. Having Russian-speaking support was very reassuring. Definitely recommended!',
        service: 'Ombre + Micro Link',
      },
      {
        name: 'Jennifer M.',
        role: 'United Kingdom',
        text: 'I was amazed by the natural look of the micro link extensions. Cemil and his team made me feel so welcome. Highly recommended for English-speaking tourists!',
        service: 'Micro Link Extensions',
      },
      {
        name: 'Büşra T.',
        role: 'Muğla',
        text: 'Got permanent blow-dry and micro link together. My hair is ready every morning now. No more daily styling stress. Very satisfied.',
        service: 'Permanent Blow-dry + Micro Link',
      },
      {
        name: 'Olga P.',
        role: 'Russia',
        text: 'Excellent work! The hair looks completely natural. The salon is very cozy, the staff is professional. I will definitely come again next year.',
        service: 'Micro Link Extensions',
      },
      {
        name: 'Fatma D.',
        role: 'Marmaris',
        text: 'I have been using micro links for 6 months. Still looks like day one. I used tape and keratin systems before, micro link is much more comfortable and natural.',
        service: 'Micro Link Extensions',
      },
    ],
    verified: 'Verified Review',
    stars: '5.0',
  },
  footer: {
    copyright: '© 2026 Cemil Kuaför | Hair Design. All rights reserved.',
    followUs: 'Follow Us',
  },
  videoDetails: {
    askMessage: 'Hello, I would like to get information and book an appointment about {{title}}.',
    durationLabel: 'Duration',
    resultLabel: 'Result Type',
    guaranteeLabel: 'Guarantee',
    detailsTitle: 'Procedure Details',
    advantagesTitle: 'Advantages',
    targetAudienceTitle: 'Who Is It For',
    items: [
      {
        title: 'Micro Link Application',
        subtitle: 'Natural-looking, damage-free premium extension application.',
        duration: '2-4 hours',
        resultType: 'Natural Result',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '156 people booked micro links this month',
        socialProofSub: 'High demand in the last 30 days',
        description:
          `Natural transitions, the most elegant form of simplicity ✨\nWe touched tiny highlights into the hair, an understated but impactful look 🌿\nWith soft tones that catch the light, elegant from every angle 💫`,
        advantages: [
          'No chemical treatment applied to hair',
          'Provides one-to-one look with natural hair',
          'Washable, ironable, dyeable',
          'Does not create a heavy feeling on the scalp',
          'Can be reused with professional removal',
        ],
        targetAudience: [
          'Those wanting volume for fine hair',
          'Those wanting length extension',
          'Suitable for hijab use',
          'Those wanting easy daily maintenance',
        ],
      },
      {
        title: 'Ombre & Color Services',
        subtitle: 'Premium results with natural gradient modern color techniques.',
        duration: '1.5-2.5 hours',
        resultType: 'Long Lasting',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '98 people had ombre done in the last 30 days',
        socialProofSub: 'Favorite color service this season',
        description:
          `Soft Luxury Wave Touch ✨\n\nShine doesn't shout… it makes itself felt. With wavy hair extensions, that effortless elegance is exactly this 💫 Voluminous, dynamic, and incredibly natural-looking waves keep your hair ready and flawless at every moment.\n\nNeither overdone nor dull… Just the right luxury feel. Adding a premium vibe to even your everyday outfits, all eyes are already on you at special occasions 🖤\n\nThe perfect touch for those who want to feel quality in their hair. Because true luxury lies in the details ✨`,
        advantages: [
          'Provides natural shine and depth effect',
          'Minimal damage with end-only coloring',
          'Lasts long without fading',
          'Daily elegance without maintenance',
          'Easy transition for re-application',
        ],
        targetAudience: [
          'Those who love modern looks',
          'Those looking for low-maintenance color',
          'Those wanting long-lasting results',
          'Those looking for tones matching their skin',
        ],
      },
      {
        title: 'Permanent Blow-dry & Keratin Care',
        subtitle: 'End daily styling hassle with smooth and shiny hair.',
        duration: '2-3 hours',
        resultType: '6-8 Month Effect',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '2,140 people have had this treatment so far',
        socialProofSub: 'Most preferred treatment in the last 6 months',
        description:
          `At Cemil Kuaför, one of the first names that comes to mind for professional hair extensions in Marmaris, the most suitable method is carefully determined for your hair, and a completely natural result is achieved.\n\nThanks to the high-quality hair we use and expert application, comfortable and long-lasting wear is provided. A natural look that you can use comfortably in daily life — indistinguishable from your own hair — awaits you ✨`,
        advantages: [
          'Reduces daily styling time by 90%',
          'Provides resistance to humidity and rain',
          'Deeply nourishes hair strands',
          'Provides shine and smoothness',
          'Straightens without losing natural movement',
        ],
        targetAudience: [
          'Curly and wavy hair',
          'Those tired of blow-drying',
          'Hair needing hydration',
          'Those looking for daily convenience',
        ],
      },
      {
        title: 'New Generation Perm',
        subtitle: 'Modern perm application that adds volume and defined waves to hair.',
        duration: '2.5-3.5 hours',
        resultType: 'Long Lasting',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '1,720 people have had modern perm so far',
        socialProofSub: 'Receiving intense interest in the last 24 hours',
        description:
          `Naturalness, volume, and flawless transition… ✨\nIn every application, we work specifically for your hair structure\nBecause everyone's transformation should be unique 💫\nThe result? Hair that regains its shine`,
        advantages: [
          'Adds volume to hair',
          'Provides defined and aesthetic wave look',
          'Creates fuller hair appearance',
          'Reduces daily styling time',
          'Applied with technique suitable for hair type',
        ],
        targetAudience: [
          'Limp hair',
          'Those wanting wavy look',
          'Those wanting styled hair',
          'Those looking for daily style',
        ],
      },
      {
        title: 'Daily Hair Care',
        subtitle: 'A practical daily care routine that maintains hair health.',
        duration: '45-60 min',
        resultType: 'Instant Shine',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '73 people purchased the daily care package this week',
        socialProofSub: 'Quick care service in high demand',
        description:
          `Long, full, flawless ✨\nYour hair isn't just about appearance, it's your energy…\nWe recreate that energy from scratch 💫\n\nWith ultra-thin, invisible, completely natural-looking micro links\nwe add volume, length, and confidence to your hair 🤍\n\nWe're here for that moment when you look in the mirror and say "I'm so glad"…\nEvery touch is professional, every result is flawless ✨\n\nYou dream it, we make it real 💌`,
        advantages: [
          'Formula that prevents frizz',
          'Moisturizes hair',
          'Quick application',
          'Suitable for daily use',
          'Preserves hair health long-term',
        ],
        targetAudience: [
          'People with a busy schedule',
          'Those seeking practical care',
          'Those who value hair health',
          'Those wanting daily shine',
        ],
      },
      {
        title: 'Color Refresh',
        subtitle: 'A quick coloring process that refreshes your current color and adds vibrant tones.',
        duration: '1-1.5 hours',
        resultType: 'Bright Result',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '112 people had color refresh in the last 14 days',
        socialProofSub: 'Favorite quick color service',
        description:
          `A completely different look with just one touch… ✨\n\nWe said goodbye to burnt, damaged, and lifeless hair; and gained long, black, and stunning hair. 🤍\nWith the professional extensions we applied, your hair now looks much fuller, healthier, and well-groomed.\n\nHair isn't just about appearance, it's about feeling…\nWe're here to help you feel stronger and more beautiful when you look in the mirror. 🖤`,
        advantages: [
          'Revitalizes faded colors',
          'Adds shine and depth',
          'Minimal chemical use',
          'Quick application',
          'Does not damage hair structure',
        ],
        targetAudience: [
          'Owners of faded color',
          'Those seeking shine',
          'Those wanting quick results',
          'Those wanting to maintain current color',
        ],
      },
      {
        title: 'Intensive Keratin Care',
        subtitle: 'Special care that deeply repairs hair strands and provides long-lasting softness.',
        duration: '1.5-2 hours',
        resultType: '3-4 Month Effect',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '215 people had keratin care in the last 30 days',
        socialProofSub: 'The essential care of the winter season',
        description:
          `Shine isn't a coincidence… it's the result of the right touches. ✨\n\nHair isn't just hair; it's a woman's energy, confidence, and the strongest reflection of her style. In this look, we're right in the middle of naturalness and luxury… 🤍\n\nThanks to the carefully applied extension procedure, the hair gained both fullness and came to life with these soft, flowing waves. Each strand was designed with the comfort and lightness that feels like your own hair. 🌿\n\nThese coffee tones that catch the light highlight your facial features; the long, voluminous, and healthy look stays with you all day without losing its effect. Because we don't just do hair… we leave you with a feeling that makes you say "I'm so glad" when you look in the mirror. 💫`,
        advantages: [
          'Repairs split ends',
          'Reduces frizz',
          'Strengthens hair strands',
          'Provides long-lasting softness',
          'Protects against heat treatments',
        ],
        targetAudience: [
          'Damaged hair',
          'Split ends',
          'Frequent heat tool users',
          'Those seeking deep care',
        ],
      },
      {
        title: 'Modern Perm Application',
        subtitle: 'Modern perm technique that adds natural waves, volume, and shape to hair.',
        duration: '2-3 hours',
        resultType: '5-7 Month Effect',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '64 people had perm in the last 7 days',
        socialProofSub: 'Trending natural wave look',
        description:
          `A flawless transformation with micro link application…\nA special touch where length, volume, and naturalness meet in the most refined way 💫\n\nEach strand is carefully applied to adapt to your hair's own structure.\nThe bonds are invisible, the feeling is light, and the result offers a completely natural integrity.\n\nThanks to the professional techniques and high-quality hair we use, it's not just an application; a personalized, long-lasting, and elegant look is achieved ✨\nA change far from exaggeration, but felt at first glance…\n\nWith micro links, we create a simple but powerful difference in your hair.\nBecause true luxury is the most perfect form of naturalness 🤍`,
        advantages: [
          'Provides natural wave look',
          'Adds volume to hair',
          'Makes daily styling easier',
          'Long-lasting',
          'Applied with technique suitable for hair type',
        ],
        targetAudience: [
          'Those wanting natural waves',
          'Straight and limp hair',
          'Those seeking daily convenience',
          'Those who love modern looks',
        ],
      },
      {
        title: 'Ombre & Balayage',
        subtitle: 'Elegant color transitions at the hair ends with a natural shine effect.',
        duration: '2-3 hours',
        resultType: 'Long Lasting',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '178 people had ombre/balayage in the last 60 days',
        socialProofSub: 'Favorite color technique in all seasons',
        description:
          `💁‍♀️ We add extra volume, movement, and unique style to your hair with micro links that offer a natural and flawless transition.\n🌿 We choose tones specifically for your hair structure; a more vibrant, shiny, and well-groomed look guaranteed!\n💫 Easy-to-style, natural yet eye-catching voluminous hair for daily use.\n🔥 Micro links made with professional techniques add long-lasting form and energy to your hair.`,
        advantages: [
          'Provides natural color transition',
          'Root protection with end coloring',
          'Requires little maintenance for a long time',
          'Tone selection matching skin color',
          'Modern and elegant look',
        ],
        targetAudience: [
          'Those seeking natural shine',
          'Those who don\'t want root dye',
          'Those who love modern looks',
          'Those wanting long-lasting color',
        ],
      },
      {
        title: 'Hair Shine Treatment',
        subtitle: 'Special serum care that instantly adds shine and vitality to hair strands.',
        duration: '30-45 min',
        resultType: 'Instant Shine',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: 'An average of 25 people get shine treatment every day',
        socialProofSub: 'Highly preferred for its quick and effective results',
        description:
          `Shine isn't a coincidence, it's the result of the right touch…\nFor depth, shine, and flawless transitions in hair, the most accurate technique is professional extension application 💫\nEach strand was placed with care, aiming for a natural look and maximum comfort.\nThe result? A fuller, more voluminous, and truly flawless look 🤍`,
        advantages: [
          'Provides instant shine',
          'Increases hair vitality',
          'Very quick application',
          'Ideal for special occasions',
          'Does not damage hair structure',
        ],
        targetAudience: [
          'Those seeking quick results',
          'Preparation for special events',
          'Dull and lifeless hair',
          'Those wanting instant shine',
        ],
      },
      {
        title: 'Professional Cut & Style',
        subtitle: 'Modern and personalized haircut and styling that suits your facial features.',
        duration: '45-75 min',
        resultType: 'Lasting Shape',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '340 people got cut and style service this month',
        socialProofSub: 'Always popular essential service',
        description:
          `The most perfect form of naturalness ✨\nWith micro links, volume, length, and silky shine come together in your hair…\nA use so natural, light, and comfortable that it's indistinguishable from your own hair 🤍`,
        advantages: [
          'Model suitable for facial features',
          'Technique tailored to hair type',
          'Makes daily maintenance easier',
          'Modern and trendy look',
          'Professional styling included',
        ],
        targetAudience: [
          'Those looking for a new model',
          'Those wanting a cut suitable for facial features',
          'Those who love modern looks',
          'Those seeking daily practicality',
        ],
      },
      {
        title: 'Bridal Hair & Makeup',
        subtitle: 'Special design, trial, and application service for your dream bridal hair.',
        duration: '2-4 hours',
        resultType: 'All-Day Lasting',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: 'We designed 89 bridal hairstyles this season',
        socialProofSub: 'The most preferred package of the wedding season',
        description:
          `💁‍♀️ With highlight application, we add natural and soft transitions of shine to your hair.\n🌿 With tones suitable for your hair structure, a more vibrant, shiny, and well-groomed look.\n💫 Easy-to-style, voluminous, and eye-catching hair for daily use.\n✨ Professional applications that maintain their form for a long time.`,
        advantages: [
          'Pre-wedding trial available',
          'Design matching the wedding dress',
          'All-day lasting styling',
          'Special hair accessories used',
          'Suitable for photo and video shoots',
        ],
        targetAudience: [
          'Brides-to-be',
          'Engagement and special day preparation',
          'Those wanting lasting styling',
          'Those seeking a professional look',
        ],
      },
      {
        title: 'Natural Wavy Model',
        subtitle: 'Wavy styling that highlights the hair\'s natural texture without using heat.',
        duration: '45-60 min',
        resultType: 'All-Day Lasting',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '56 people chose this model in the last 30 days',
        socialProofSub: 'The favorite of the natural beauty trend',
        description:
          `Give your hair the care it deserves… 🌿\nAt Cemil Kuaför, hair extension procedures are applied with personalized analysis, aiming for the most natural result. 💇‍♀️✨\n\nRediscover your confidence with shiny, full, and flawless-looking hair. 💫`,
        advantages: [
          'Styles without heat',
          'Preserves hair health',
          'Provides natural wave look',
          'Lasts all day',
          'Can be applied daily',
        ],
        targetAudience: [
          'Those who love natural looks',
          'Those avoiding heat treatments',
          'Those who value hair health',
          'Those wanting soft waves',
        ],
      },
      {
        title: 'Intensive Volume Application',
        subtitle: 'Special cut and styling that adds fullness and volume to fine hair.',
        duration: '1-1.5 hours',
        resultType: 'Instant Volume',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '134 people had volume application in the last 30 days',
        socialProofSub: 'The savior of fine hair',
        description:
          `The long and full hair of your dreams is now possible ✨\nAt Cemil Kuaför, we give your hair a new life with professional hair extension applications 💇‍♀️💖\nRediscover yourself with a natural look, perfect harmony, and lasting results.`,
        advantages: [
          'Provides instant fullness',
          'Lifts hair roots',
          'Supported with special volume products',
          'Makes daily styling easier',
          'Long-lasting effective result',
        ],
        targetAudience: [
          'Fine hair',
          'Those lacking volume',
          'Those wanting a full look',
          'Those seeking root lift',
        ],
      },
      {
        title: 'Creative Hair Design',
        subtitle: 'Unique and artistic hair designs that reflect your personality.',
        duration: '1.5-3 hours',
        resultType: 'Unique Design',
        guarantee: 'Satisfaction Guaranteed',
        socialProof: '47 people had creative design in the last 90 days',
        socialProofSub: 'The choice of those seeking an original style',
        description:
          `At Cemil Kuaför, hair extension procedures are meticulously planned not just for length, but to capture the most natural harmony suitable for your hair structure, skin tone, and style. 💇‍♀️💫`,
        advantages: [
          'Fully personalized design',
          'Color and cut combination',
          'Original and artistic result',
          'Professional consultation included',
          'Trend and modern techniques',
        ],
        targetAudience: [
          'Those seeking an original style',
          'Those who love artistic looks',
          'Those who prefer colorful hair',
          'Those wanting a unique design',
        ],
      },
    ],
  },
};